import { Dashboard } from '@uppy/react';
import { Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import React, { useEffect } from 'react';
import Uppy from '@uppy/core';
import { localeUppy } from '../../Modules/Internationalization/translations/en';
import { useForm } from 'react-final-form';
interface IProps {
  addtionalLabel?: string;
  disabled?: boolean;
  documentValue?;
  fieldName?: string;
  formName?: string;
  handleOnChange?: (file: any, meta: any, form: any) => void;
  height?: number;
  idComponent?: string;
  input?: any;
  label?: string;
  labelClassName?: string;
  labelKey?: any;
  meta?: any;
  uppyConfig?: any;
  useFile?: boolean;
  additionalOnchange?: any;
  actionDeleteDispatch?: any;
  paramsDispatch?: any;
  documentMeta?: any;
}

const fileCache: Record<string, any> = {};

export const InputFileRegisForm = (props: IProps) => {
  const {
    addtionalLabel,
    documentValue,
    fieldName,
    formName,
    handleOnChange,
    height,
    idComponent,
    label,
    labelClassName,
    meta: { error },
    uppyConfig,
    labelKey,
    useFile,
    input,
    additionalOnchange,
    documentMeta,
  } = props;

  const {
    maxFile,
    minFile,
    allowedFile,
    maxSize,
    documentCode,
    documentType,
    name,
    contentId,
    folderId,
    repositoryId,
    sectionKey,
    fileName,
    documentGroup,
  } = uppyConfig;

  const formAPI = useForm();
  const formValue = formAPI.getState().values;
  function useUppy(factory: any) {
    return React.useMemo(factory, []);
  }
  const uppyInput: any = useUppy(() => {
    const uppy = new Uppy({
      restrictions: {
        minNumberOfFiles: minFile,
        maxNumberOfFiles: maxFile,
        allowedFileTypes: allowedFile,
        maxFileSize: maxSize,
      },
      id: input?.name,
      locale: localeUppy,
      autoProceed: true,
    });

    return uppy;
  });

  useEffect(() => {
    if (input && input.value) {
      const files = Array.isArray(input.value) ? input.value : [input.value];
      const uppyFiles = uppyInput.getFiles();
      if (uppyFiles.length === 0) {
        files.forEach((f: any) => {
          if (f) {
            const fileData = f.file || f.data || f;
            if (fileData instanceof File || fileData instanceof Blob) {
              try {
                const addedId = uppyInput.addFile({
                  name:
                    f.name ||
                    (fileData instanceof File ? fileData.name : 'file'),
                  type: f.type || fileData.type,
                  data: fileData,
                  source: 'Local',
                  isRemote: false,
                  meta: { isPrepopulated: true, originalData: f },
                });

                let previewToSet =
                  f.preview ||
                  (f.meta &&
                    f.meta.originalData &&
                    f.meta.originalData.preview);
                const fType = fileData.type || f.type || '';
                const fName = (fileData as any).name || f.name || '';
                const isImage =
                  fType.startsWith('image/') ||
                  /\.(jpe?g|png|gif|bmp|webp)$/i.test(fName);

                if (
                  previewToSet &&
                  typeof previewToSet === 'string' &&
                  previewToSet.startsWith('blob:')
                ) {
                  if (isImage) {
                    previewToSet = URL.createObjectURL(fileData);
                  } else {
                    previewToSet = undefined;
                  }
                } else if (!previewToSet && isImage) {
                  previewToSet = URL.createObjectURL(fileData);
                }

                if (previewToSet && isImage) {
                  uppyInput.setFileState(addedId, {
                    preview: previewToSet,
                  });
                }
              } catch (err) {
                console.error('Uppy prepopulate error:', err);
              }
            } else if (fileData && fileData.name && fileData.size) {
              try {
                const fType = fileData.type || f.type || '';
                const fName = fileData.name || f.name || 'file';
                const isPdf =
                  fType === 'application/pdf' ||
                  /\.pdf$/i.test(fName);
                const isImage =
                  !isPdf &&
                  (fType.startsWith('image/') ||
                    /\.(jpe?g|png|gif|bmp|webp)$/i.test(fName));
                const finalType = isPdf
                  ? 'application/pdf'
                  : fType || (isImage ? 'image/jpeg' : 'application/octet-stream');

                // Mock a blob if we only have plain object
                const blob = new Blob([''], {
                  type: finalType,
                });
                (blob as any).name = fName;
                const addedId = uppyInput.addFile({
                  name: fName,
                  type: finalType,
                  data: blob,
                  source: 'Local',
                  isRemote: false,
                  meta: { isPrepopulated: true, originalData: f },
                });
                if (
                  isImage &&
                  (f.preview ||
                    (f.meta && f.meta.originalData && f.meta.originalData.preview))
                ) {
                  uppyInput.setFileState(addedId, {
                    preview:
                      f.preview ||
                      (f.meta &&
                        f.meta.originalData &&
                        f.meta.originalData.preview),
                  });
                }
              } catch (err) {
                console.error('Uppy prepopulate mock error:', err);
              }
            } else if (typeof fileData === 'string' && fileData.length > 0) {
              try {
                const cacheKey = fieldName || input?.name || idComponent;
                const cached = cacheKey ? fileCache[cacheKey] : null;
                const metaFile =
                  (documentMeta &&
                    documentMeta.files &&
                    fieldName &&
                    documentMeta.files[fieldName]) ||
                  (documentMeta &&
                    documentMeta.files &&
                    input?.name &&
                    documentMeta.files[input.name]) ||
                  (documentMeta &&
                    documentMeta.field === fieldName &&
                    documentMeta.file) ||
                  cached ||
                  null;

                let mimeType =
                  metaFile?.type ||
                  (documentValue &&
                    documentValue.properties &&
                    (documentValue.properties.mime ||
                      documentValue.properties.type));
                let actualFileName =
                  metaFile?.name ||
                  (documentValue &&
                    (documentValue.originalFileName ||
                      documentValue.fileName ||
                      (documentValue.properties &&
                        documentValue.properties.fileName)));
                let actualExt =
                  metaFile?.extension ||
                  (documentValue &&
                    documentValue.properties &&
                    documentValue.properties.extension);

                if (!actualExt && actualFileName) {
                  const match = actualFileName.match(/\.([a-zA-Z0-9]+)$/);
                  if (match) actualExt = match[1];
                }

                if (!mimeType) {
                  if (
                    actualExt === 'pdf' ||
                    actualExt === '.pdf' ||
                    (actualFileName && /\.pdf$/i.test(actualFileName))
                  ) {
                    mimeType = 'application/pdf';
                  } else if (
                    actualExt &&
                    /^(jpe?g|png|gif|bmp|webp)$/i.test(
                      actualExt.replace(/^\./, ''),
                    )
                  ) {
                    const cleanExt = actualExt.replace(/^\./, '').toLowerCase();
                    mimeType = cleanExt === 'png' ? 'image/png' : 'image/jpeg';
                  } else if (
                    allowedFile &&
                    allowedFile.length === 1 &&
                    allowedFile[0] === '.pdf'
                  ) {
                    mimeType = 'application/pdf';
                  } else {
                    const ext =
                      allowedFile && allowedFile.length > 0
                        ? allowedFile[0]
                        : '.jpg';
                    mimeType =
                      ext === '.pdf' ? 'application/pdf' : 'image/jpeg';
                  }
                }

                const isPdf =
                  mimeType === 'application/pdf' ||
                  actualExt === 'pdf' ||
                  actualExt === '.pdf' ||
                  (actualFileName && /\.pdf$/i.test(actualFileName));

                const isImage =
                  !isPdf &&
                  ((mimeType && mimeType.startsWith('image/')) ||
                    (actualFileName &&
                      /\.(jpe?g|png|gif|bmp|webp)$/i.test(actualFileName)));

                const ext = isPdf
                  ? '.pdf'
                  : actualExt
                    ? actualExt.startsWith('.')
                      ? actualExt
                      : `.${actualExt}`
                    : allowedFile && allowedFile.length > 0
                      ? allowedFile[0]
                      : '.jpg';

                const mockFileName =
                  actualFileName || `${fileName || 'Attached File'}${ext}`;

                let blob: Blob;
                if (metaFile?.data instanceof Blob) {
                  blob = metaFile.data;
                } else {
                  blob = new Blob([' '], { type: mimeType });
                  (blob as any).name = mockFileName;
                }

                const addedId = uppyInput.addFile({
                  name: mockFileName,
                  type: mimeType,
                  data: blob,
                  source: 'Local',
                  isRemote: false,
                  meta: { isPrepopulated: true, originalData: fileData },
                });

                // Only set the preview if the file is an image!
                if (isImage) {
                  const previewToSet =
                    metaFile?.preview ||
                    (documentMeta &&
                      documentMeta.previews &&
                      fieldName &&
                      documentMeta.previews[fieldName]) ||
                    (documentMeta &&
                      documentMeta.field === fieldName &&
                      documentMeta.preview) ||
                    (documentValue && documentValue.content) ||
                    (blob instanceof Blob && blob.size > 1
                      ? URL.createObjectURL(blob)
                      : undefined);

                  if (previewToSet) {
                    uppyInput.setFileState(addedId, {
                      preview: previewToSet,
                    });
                  }
                }
              } catch (err) {
                console.error('Uppy prepopulate mock string error:', err);
              }
            }
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [uppyInput, input]);

  useEffect(() => {
    const fileArr: any[] = [];
    const filesContainer = uppyInput.store.state.files;
    for (const key in filesContainer) {
      if (Object.prototype.hasOwnProperty.call(filesContainer, key)) {
        const element = filesContainer[key];
        const isPrepopulated = element.meta && element.meta.isPrepopulated;
        const file = element.data;
        const handleFile = useFile === true ? file : undefined;
        const date = new Date();
        const dateNow = Date.now();
        const isoTimeStamp = date.toISOString();
        const additionalMeta = {
          field: fieldName,
          form: formName,
          documentCode,
          documentType,
          name,
          contentId,
          folderId,
          repositoryId,
          sectionKey,
          fileName,
          dateNow,
          isoTimeStamp,
          documentGroup,
        };

        if (!isPrepopulated) {
          const cacheKey = fieldName || input?.name || idComponent;
          if (cacheKey) {
            fileCache[cacheKey] = {
              name: element.name,
              type: element.type,
              extension: element.extension,
              size: element.size,
              data: file,
              preview: element.preview,
            };
          }
        }

        if (handleOnChange && !isPrepopulated) {
          handleOnChange(element, additionalMeta, formAPI);
        }

        if (isPrepopulated && element.meta.originalData) {
          fileArr.push(element.meta.originalData);
        } else {
          fileArr.push({
            ...additionalOnchange,
            ...handleFile,
            file: file,
            name: element.name,
            label: labelKey,
            size: element.size,
            type: element.type,
            extension: element.extension,
            preview: element.preview,
          });
        }
      }
    }

    if (fileArr.length > 0) {
      input.onChange(fileArr.length > 1 ? fileArr : fileArr[0]);
    }
    // eslint-disable-next-line
  }, [uppyInput.store.state.files]);

  useEffect(() => {
    // Sync UI with form state: if the field is cleared programmatically, clear Uppy files
    if (
      uppyInput &&
      (!input ||
        !input.value ||
        (Array.isArray(input.value) && input.value.length === 0))
    ) {
      if (uppyInput.getFiles().length > 0) {
        uppyInput.cancelAll();
      }
    }
  }, [input, uppyInput]);

  useEffect(() => {
    const handleFileAdded = (file: any) => {
      input.onChange(file);
    };

    const handleFileRemoved = (file: any) => {
      const cacheKey = fieldName || input?.name || idComponent;
      if (cacheKey && fileCache[cacheKey]) {
        delete fileCache[cacheKey];
      }
      if (input.value instanceof Array) {
        const tempData = [...input.value];
        const filteredData = tempData.filter(val => {
          return val.name !== file.name;
        });
        input.onChange(filteredData);
      } else {
        input.onChange(null);
      }
    };

    uppyInput.on('file-added', handleFileAdded);
    uppyInput.on('file-removed', handleFileRemoved);

    return () => {
      uppyInput.off('file-added', handleFileAdded);
      uppyInput.off('file-removed', handleFileRemoved);
    };
  }, [uppyInput, input, fieldName, idComponent]);

  const labelTitle = (
    <span>
      <b className={`capital ${labelClassName}`}>
        <FormattedMessage id={label} />
      </b>
      <span className="colorLightGrey">
        {addtionalLabel ? ` ${addtionalLabel}` : null}
      </span>
    </span>
  );

  return (
    <Form.Item
      validateStatus={
        documentValue && formValue === null && error !== undefined
          ? 'error'
          : ''
      }
      help={
        documentValue && formValue === null && error !== undefined ? error : ''
      }
      label={labelTitle}
      colon={false}
    >
      <Dashboard
        id={idComponent}
        uppy={uppyInput}
        width={'100%'}
        height={height ? height : 150}
        hideUploadButton={true}
        proudlyDisplayPoweredByUppy={false}
      />
    </Form.Item>
  );
};
